import { ApiResponse } from './../../models/api-response.model';
import { MyAccountService } from './../../services/myAccount.service';
import { Component, OnInit, HostBinding } from '@angular/core';
import { slideToRight } from '../../shared/animations.collections';
import { CreateEventService } from '../../nav/shared/createevent.listener';
import { UserInfoViewModel } from '../../models/account-ledger.model';

declare var $: any;

@Component({
  selector: 'app-sales-doc',
  templateUrl: './sales-doc.component.html',
  styleUrls: ['./sales-doc.component.css'],
  animations: [slideToRight('100%')]
})
export class SalesDocComponent implements OnInit {
  @HostBinding('@slideToRight') ani;

  userInfo: UserInfoViewModel = <UserInfoViewModel>{};
  loginId = '';

  constructor( 
    private pageService: CreateEventService,
    private myAccountService: MyAccountService
    ) {}

  ngOnInit() {

    this.getDocumentsInfo();
    
  }

  getDocumentsInfo() {
    this.myAccountService.GetSalesDocuments(this.loginId).subscribe((value: UserInfoViewModel) => {
      this.userInfo = value;
    });
  }

  updateSalesDocuments() {
    this.myAccountService.UpdateSalesDocuments(this.userInfo).subscribe((res: ApiResponse) => {
         
        if(res.status === true) {
          $('.confirmButton').showValidator(res.responseMessage, 'success', 'left');
        } else {
          $('.confirmButton').showValidator(res.responseMessage, 'error', 'left');
        }
    });
  }

  closePage() {

    this.pageService.destoryComponent('person');
  }
}
